import React from "react";
import { StatusPill } from "./StatusPill";
import { fmtDate } from "../lib/format";
import { Check } from "lucide-react";

// Vertical "subway map" timeline of milestones
export function Timeline({ milestones = [] }) {
  return (
    <div className="relative" data-testid="timeline">
      {milestones.map((m, i) => {
        const done = m.status === "Completed";
        const current = m.status === "Current";
        return (
          <div key={m.id || i} className="flex gap-4 group" data-testid={`milestone-${i}`}>
            <div className="flex flex-col items-center">
              <div className={`h-5 w-5 rounded-full border-2 flex items-center justify-center shrink-0 z-10 transition-colors
                ${done ? "bg-arq-green border-arq-green" : current ? "bg-arq-card border-arq-accent" : "bg-arq-card border-border"}`}>
                {done ? <Check className="h-3 w-3 text-white" strokeWidth={3} /> : current ? <span className="h-2 w-2 rounded-full bg-arq-accent animate-pulse" /> : null}
              </div>
              {i < milestones.length - 1 && (
                <div className={`w-0.5 flex-1 min-h-[44px] ${done ? "bg-arq-green" : "bg-border"}`} />
              )}
            </div>
            <div className="pb-8 -mt-0.5 flex-1">
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <p className={`font-medium ${current ? "text-arq-ink" : done ? "text-arq-ink" : "text-muted-foreground"}`}>{m.name}</p>
                {(current || m.status === "Upcoming") && <StatusPill status={m.status === "Current" ? "In Progress" : m.status} />}
              </div>
              <p className="text-xs text-muted-foreground mt-0.5">{fmtDate(m.date)}</p>
              {m.description && <p className="text-sm text-muted-foreground mt-1">{m.description}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
